<template lang="pug">
  .component-selectize-grouped-parking-assets
    label(v-if="parkingGroups") Parking Group
      selectize(:options="parkingGroups", :optionTemplate="optionPgTemplate", :renderTemplate="renderPgTemplate", :maxItems="1", @itemAdded="pgSelected", @itemRemoved="clearLotAndSlot")
    label(v-if="parkingLots") Parking Lot
      selectize(:options="parkingLots", :optionTemplate="optionPgTemplate", :renderTemplate="renderPgTemplate", :maxItems="1", ref="selectizeParkingLots", @itemAdded="plSelected", @itemRemoved="plUnselected")
    label(v-if="parkingSlots") Parking Slot
      selectize(:options="parkingSlots", :optionTemplate="optionPgTemplate", :renderTemplate="renderPgTemplate", :maxItems="1", ref="selectizeParkingSlots", @itemAdded="psSelected")

</template>

<script>
  import Selectize from "../../../Selectize";
  import KeplerBackofficeSdk from "../../../../../lib/kepler/backoffice";

  export default {
    name: "SelectizeGroupedParkingAssets",
    components: {Selectize},
    data() {
      return {
        parkingGroups: null,
        parkingLots: null,
        parkingSlots: null,
      }
    },
    created() {
      KeplerBackofficeSdk.parkingGroups.list.all((data) => {
        this.parkingGroups = data
      })
    },
    methods: {
      optionPgTemplate(item, escape) {
        return `<div>PG${item.id} ${item.name}</div>`
      },
      renderPgTemplate(item, escape) {
        return `<div>${item.name}</div>`
      },
      plUnselected() {
        this.parkingSlots = null
        if (this.$refs.selectizeParkingSlots !== undefined) {
          this.$refs.selectizeParkingSlots.clearOptions()
        }
      },
      pgSelected(pg) {
        this.clearLotAndSlot()
        this.parkingGroups.forEach((item) => {
          if (pg.id === item.id) {
            if (this.$refs.selectizeParkingLots !== undefined) {
              this.$refs.selectizeParkingLots.addOption(item.parking_lots)
            }
            this.parkingLots = item.parking_lots
          }
        })
      },
      plSelected(pl) {
        this.parkingSlots = null
        if (this.$refs.selectizeParkingSlots !== undefined) {
          this.$refs.selectizeParkingSlots.clearOptions()
        }

        KeplerBackofficeSdk.parkingLots.select(pl.id).get((data) => {
          this.parkingSlots = data.parking_slots
        })

      },
      clearLotAndSlot() {
        this.parkingLots = null
        if (this.$refs.selectizeParkingLots !== undefined) {
          this.$refs.selectizeParkingLots.clearOptions()
        }
        this.plUnselected()
      },
      psSelected(ps) {
        this.$emit('parkingSlotSelected', ps)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SelectizeGroupedParkingAssets.vue?04e95b2e